export default __webpack_public_path__ + "static/media/bannerLogo-pinkBlack.a8b7b7ec.png";